export default __webpack_public_path__ + "static/media/(27).0f5ca52e.JPG";